import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
	Button,
	Col,
	Form,
	Input,
	Modal,
	PageHeader,
	Row,
	Select,
	Table,
	Tooltip,
} from "antd";
import moment from "moment-jalaali";

import {
	CheckPermission,
	GetUrlParams,
	ObjectToURL,
	PriceFormat,
} from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import { MinuteFormat } from "scripts/helpers";
import { Modals, Permissions, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";

import FormModal from "modals/PackageForm";

const Component = ({
	currency,
	onSetRoute,
	routeName,
	parentName,
	permissions,
}) => {
	const initialState = { courses: [], data: [], images: [], files: [] };
	const tableColumns = [
		{
			title: Resources.row,
			dataIndex: "index",
			className: "center-cell",
			width: "60px",
			render: (value, record, index) => index + 1,
		},
		{
			title: Resources.title,
			dataIndex: "title",
		},
		// {
		// 	title: Resources.description,
		// 	className: "center-cell",
		// 	dataIndex: "description",
		// 	render: (value) => (
		// 		<div
		// 			dangerouslySetInnerHTML={{
		// 				__html: value.length > 20 ? value.substr(1, 20) + "..." : value,
		// 			}}
		// 		/>
		// 	),
		// 	// value.length > 20 ? value.substr(1, 20) + "..." : value,
		// },
		{
			title: `${Resources.course}${Resources.ha}`,
			className: "center-cell",
			dataIndex: "courses",
			render: (value) =>
				value?.map(({ label }, i) => {
					return i + 1 === value.length ? label : `${label}, `;
				}),
		},
		{
			title: Resources.price,
			className: "center-cell desc-cell",
			dataIndex: "price",
			width: "80px",
			render: (value) => (
				<>
					<span className="name">{PriceFormat(value)}</span>
					<small className="desc">{currency}</small>
				</>
			),
		},

		{
			title: Resources.status,
			className: "center-cell color-cell",
			dataIndex: "status",
			width: "80px",
			render: (value, record) =>
				permissions.status ? (
					<span
						className={`btn ${value ? "green" : "red"}`}
						onClick={() => handleStatus(record)}
					>
						{value ? Resources.active : Resources.inactive}
					</span>
				) : (
					<span className={value ? "green" : "red"}>
						{value ? Resources.active : Resources.inactive}
					</span>
				),
		},
		{
			title: `${Resources.date} ${Resources.create}`,
			dataIndex: "createdAt",
			className: "center-cell desc-cell ltr-cell",
			width: "100px",
			render: (value) => {
				const [date, time] = moment(value)
					.format(process.env.REACT_APP_DATE_TIME_FORMAT_JALALI)
					.split(" ");

				return (
					<>
						<span className="name">{date}</span>
						<small className="desc">{time}</small>
					</>
				);
			},
		},
		{
			title: Resources.action,
			dataIndex: "id",
			className: "center-cell",
			width: "200px",
			render: (value, record) => (
				<>
					{permissions.update && (
						<Tooltip title={Resources.edit}>
							<Button
								type="link"
								icon={<i className="fa fa-pencil-alt" />}
								onClick={() => handleForm(record)}
							/>
						</Tooltip>
					)}
					{permissions.delete && (
						<Tooltip title={Resources.delete}>
							<Button
								type="link"
								icon={<i className="fa fa-trash-alt" />}
								onClick={() => {
									handleDelete(record.id);
								}}
							/>
						</Tooltip>
					)}
				</>
			),
		},
	];
	const [state, setState] = useState(initialState);
	const { courses, data, fetching, loading, selected, images, files } = state;
	const { pathname, search } = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const fetchData = () => {
		const params = GetUrlParams(search);

		form.resetFields();
		form.setFieldsValue(params);

		setState((prevState) => ({ ...prevState, loading: true }));

		API.package
			.list({ ...params, paginate: false })
			.then(({ data }) => {
				const formattedData = data.map((pack) => {
					return {
						...pack,
						courses: pack.courses.map(({ id, title }) => {
							return { label: title, value: id };
						}),
					};
				});

				console.log("data:", data);
				console.log("formattedData", formattedData);
				setState((prevState) => ({
					...prevState,
					data: formattedData,
					loading: false,
				}));
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loading: false }));
			});
	};

	const handleForm = (selected, reload) => {
		if (reload) {
			fetchData();
		} else {
			setState((prevState) => ({ ...prevState, selected }));

			navigate(
				`${pathname}${search}#${selected ? Modals.EDIT : Modals.CREATE}`
			);
		}
	};

	const handleStatus = (selected) => {
		Modal.confirm({
			title: Resources.statusConfirm,
			okText: Resources.yes,
			okType: "danger",
			cancelText: Resources.no,
			onOk: () => {
				setState((prevState) => ({ ...prevState, loading: true }));

				API.package
					.status(selected.code)
					.then(() => {
						setState((prevState) => ({ ...prevState, loading: false }));

						fetchData();
					})
					.catch(() => {
						setState((prevState) => ({ ...prevState, loading: false }));
					});
			},
		});
	};

	const handleDelete = (code) => {
		Modal.confirm({
			title: Resources.deleteConfirm,
			okText: Resources.yes,
			okType: "danger",
			cancelText: Resources.no,
			onOk: () => {
				setState((prevState) => ({ ...prevState, loading: true }));

				API.package
					.delete(code)
					.then(() => {
						fetchData();
					})
					.catch(() => {
						setState((prevState) => ({ ...prevState, loading: false }));
					});
			},
		});
	};

	const handleFilter = debounce(() => {
		form.validateFields().then((values) => {
			const search = ObjectToURL({ page: 1, ...values });

			navigate(`${pathname}?${search}`);
		});
	}, 1000);

	const componentDidUpdate = () => {
		fetchData();
	};

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });

		Promise.all([
			API.course.list({ paginate: false }),
			API.gallery.list({ paginate: false, section: "package" }),
			API.files.list({ paginate: false }),
		])
			.then(([{ data: courses }, { data: images }, { data: files }]) => {
				setState((prevState) => ({
					...prevState,
					courses: courses.map(({ id, title }) => ({
						value: id,
						label: title,
					})),
					images: images.map(({ id, title, file }) => ({
						label: title,
						file,
						value: id,
					})),
					files: files.map(({ id, title }) => ({
						value: id,
						label: title,
					})),
				}));
			})
			.catch(() => {});
	};

	useEffect(componentDidUpdate, [search]);
	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader
				title={`${Resources.package}${Resources.ha}`}
				extra={
					permissions.create && (
						<Button
							type="primary"
							onClick={() => handleForm()}
							disabled={loading}
						>
							{Resources.add}
						</Button>
					)
				}
			/>

			<Form
				layout="vertical"
				form={form}
			>
				<Row gutter={24}>
					<Col
						xs={24}
						sm={12}
						md={8}
						lg={6}
						xxl={4}
					>
						<Form.Item name="search">
							<Input
								suffix={<i className="fa fa-search" />}
								onChange={handleFilter}
								placeholder={Resources.search}
								allowClear
								autoFocus
							/>
						</Form.Item>
					</Col>
					<Col
						xs={24}
						sm={12}
						md={8}
						lg={6}
						xxl={4}
					>
						<Form.Item name="courses">
							<Select
								onChange={handleFilter}
								options={courses}
								placeholder={Resources.course}
								allowClear
							/>
						</Form.Item>
					</Col>
					<Col
						xs={24}
						sm={12}
						md={8}
						lg={6}
						xxl={4}
					>
						<Form.Item name="status">
							<Select
								onChange={handleFilter}
								options={[
									{ value: "true", label: Resources.active },
									{ value: "false", label: Resources.inactive },
								]}
								placeholder={Resources.status}
								allowClear
							/>
						</Form.Item>
					</Col>
				</Row>
			</Form>

			<Table
				columns={tableColumns}
				dataSource={data}
				loading={loading}
				pagination={false}
				scroll={{ x: 930 }}
				rowKey="id"
			/>

			<FormModal
				data={selected}
				onUpdate={handleForm}
				options={{ courses, images, files }}
			/>
		</>
	);
};

export default connect(
	(state) => {
		return {
			currency: state.settings.currency,
			permissions: {
				create: CheckPermission(
					state.user.permissions,
					Permissions.PACKAGE_CREATE
				),
				delete: CheckPermission(
					state.user.permissions,
					Permissions.PACKAGE_DELETE
				),
				update: CheckPermission(
					state.user.permissions,
					Permissions.PACKAGE_UPDATE
				),
				status: CheckPermission(
					state.user.permissions,
					Permissions.PACKAGE_STATUS
				),
			},
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
